export default {
	requestLoading: 0,
	theme: localStorage.getItem('theme') ?? 'light',
	showSidebar: localStorage.getItem('showSidebar') === 'true' ? true : false,
	icon_size: localStorage.getItem('icon_size') ?? 'md',
	carousel_orientation:
		localStorage.getItem('carousel_orientation') ?? 'scroll',
	menu_order: JSON.parse(localStorage.getItem('menu_order') ?? '[]'),
	modules: [],
	modalities: [],
	dicom_modalities: [],
	schedules: [],
	last_modality_id: null,
	keep_connected: JSON.parse(localStorage.getItem('keep_connected')) ?? {
		active: false,
		time: 15,
	},
	favoriteRouteName: localStorage.getItem('favoriteRouteName') ?? '',
	selectedReceptionCounter:
		sessionStorage.getItem('selectedReceptionCounter') ?? 0,
	toolBar: false,
	infoBar: false,
	subtitle: false,
}
